module.exports = __webpack_public_path__ + "img/Clothing-Downjacket.0d41c063.jpg";